import { render } from "./UsersDetail.vue?vue&type=template&id=5a2570d2&scoped=true"
import script from "./UsersDetail.vue?vue&type=script&lang=js"
export * from "./UsersDetail.vue?vue&type=script&lang=js"

import "./UsersDetail.vue?vue&type=style&index=0&id=5a2570d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a2570d2"]])

export default __exports__